<template>
  <div>
    <v-col cols="12" class="border">
      <b>Users' Profile</b>
      <table class="tbl tbl-center" style="margin-top: 5px" v-if="!dialogEdit">
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.name"
              label="Name"
              style="pointer-events: none"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.phone"
              label="Phone Number"
              style="pointer-events: none"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.bank_account_number"
              label="Bank Account Number"
              style="pointer-events: none"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.username"
              label="Account"
              style="pointer-events: none"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.email"
              label="Email"
              style="pointer-events: none"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="roles"
              label="Roles"
              style="pointer-events: none"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-btn
              color="warning"
              small
              @click="dialogEdit = true"
              style="margin-top: 3px"
              >Edit <v-icon small>mdi-pencil</v-icon></v-btn
            >&nbsp;
            <v-btn
              color="yellow"
              small
              @click="dialogPassword = !dialogPassword"
              style="margin-top: 3px"
              >Change Password</v-btn
            >
          </td>
        </tr>
      </table>

      <table class="tbl tbl-center" style="margin-top: 5px" v-else>
        <tr v-if="error">
          <td>
            <v-alert type="error" style="text-align: left">
              Username cannot contains "@" and ".". Email cannot be empty and
              must be syntactically correct:<br />
              Eg: email_name@domain
            </v-alert>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.name"
              label="Name"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.phone"
              label="Phone Number"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.bank_account_number"
              label="Bank Account Number"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.username"
              label="Account"
              disabled
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              v-model="profileUser.email"
              label="Email"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field v-model="roles" label="Roles" disabled></v-text-field>
          </td>
        </tr>
        <tr>
          <td style="text-align: right">
            <v-btn color="success" @click="save">Save</v-btn>
            &nbsp;
            <v-btn color="danger" @click="cancel">Cancel</v-btn>
          </td>
        </tr>
      </table>
      <!-- <button @click="signOut" class="btn btn-lg btn-danger" style="margin-top:10px">Sign Out</button> -->
    </v-col>

    <BaseDialog :active.sync="dialogPassword" dialog_name="Change Password">
      <password />
    </BaseDialog>
  </div>
</template>

<script>
import password from "./c-change-password";
import BaseDialog from "../Common/c-base-dialog";
import Amplify, { Auth } from "aws-amplify";
import moment from "moment-timezone";
import axios from "axios";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  Amplify,
  name: "sign-out",
  components: {
    password,
    BaseDialog,
  },

  created() {
    this.$root.$refs.profile = this;
  },

  data() {
    return {
      tab: null,
      dialogPassword: false,
      dialogEdit: false,
      account: "",
      password: "",
      response: [],
      profileUser: [],
      AuthStr: "",
      username: "",
      roles: "",
      phone: "",
      error: "",
      notificationData: [],
      search: "",
      loading: false,
      headers: [
        {
          text: "Message",
          align: "start",
          value: "message",
        },
        { text: "Create Date", value: "created_date" },
      ],
    };
  },

  methods: {
    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "user-profile-loadData"
      );
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "users/" + currentSession.username, {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            // If request is good...
            //console.log(response)
            this.profileUser = response.data.data;

            if (this.profileUser.roles.length > 1) {
              this.roles = this.profileUser.roles.join(", ");
              console.log("roles: ", this.roles);
            } else {
              this.roles = this.profileUser.roles[0];
            }

            console.log("user-profile: ", this.profileUser);
          })
          .catch((error) => {
            console.log("error " + error);
          });
      } else {
        console.log("currentSession user-profile-loadData: ", currentSession);
      }
    },

    async loadNotification() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "user-profile-loadNotification"
      );
      if (currentSession.accessToken) {
        await axios
          .get(
            window.domain +
              "users/" +
              currentSession.username +
              "/notifications?itemsPerPage=10&page=1",
            { headers: { Authorization: currentSession.accessToken } }
          )
          .then((response) => {
            console.log("loadNotification response: ", response);
            this.notificationData = response.data.data.notifications;
            for (const i of this.notificationData) {
              i.created_date = moment(i.created_date)
                .tz("America/Los_Angeles")
                .format("DD/MMM/YYYY - HH:mm:ss");
            }
          })
          .catch((err) => console.log(err));
      } else {
        console.log(
          "currentSession user-profile-loadNotification: ",
          currentSession
        );
      }
      console.log("notificationData: ", this.notificationData);
    },

    cancel() {
      this.dialogEdit = false;
      this.loadData();
      this.error = "";
    },

    turnOffDialog() {
      this.dialogPassword = false;
    },

    async save() {
      var check1 = false;
      var check2 = false;
      var temp1 = this.profileUser.username.toString();
      var temp2 = this.profileUser.email.toString();

      if (temp1.indexOf("@") == -1 && temp1.indexOf(".") == -1) {
        check1 = true;
      }

      if (temp2.indexOf("@") != -1 && temp2.indexOf(".") != -1) {
        check2 = true;
      }

      if (check1 == true && check2 == true) {
        var currentSession = await this.$root.$refs.App.currentSession(
          "user-profile-save"
        );
        if (currentSession.accessToken) {
          await fetch(window.domain + "users/" + currentSession.username, {
            method: "PUT",
            headers: { Authorization: currentSession.accessToken },
            body: JSON.stringify(this.profileUser),
          })
            .then((response) => response.json())
            .then((data) => {
              console.log("profile-response: ", data);
              this.profileUser.name = data.data.name;
              //this.profileUser.phone = data.data.phone.slice(3,data.data.phone.length);
              this.profileUser.email = data.data.email;
            })
            .catch((error) => console.log(error));
          this.dialogEdit = false;
        } else {
          this.error = true;
        }
      }
    },
  },
  async mounted() {
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      this.loadData();
      this.loadNotification();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.tbl-center {
  margin-left: auto;
  margin-right: auto;
  border: 25px #f2f2f2 solid;
  border-radius: 5px;
  background-color: #f2f2f2;
  width: 100%;
}
</style>